import { createSelector } from 'reselect';
import { getBatchNotes } from '../rootSelectors';

const getAllBatchNotesByBatchIdSelector = createSelector([getBatchNotes], batchNotes => batchNotes);

const getShowBatchNotesModal = createSelector([getBatchNotes], batchNotes => batchNotes.batchNotesModal);

export { getAllBatchNotesByBatchIdSelector, getShowBatchNotesModal };
